import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { TableSearchListdDef } from '~/componentslocal';

import Charts from 'react-apexcharts';
import PropTypes from 'prop-types';

import { isEmpty, round } from 'lodash';
import { format, parseISO } from 'date-fns';
import { parseDateString } from '~/helpers';

export default function GraphicAbastecimentoDiaNoite({
    data,
    sending,
    visible,
    toggleDisabled,
}) {

    const [volumesTotal, setVolumesTotal] = useState([])
    const [volumesDia, setVolumesDia] = useState([])
    const [volumesNoite, setVolumesNoite] = useState([])

    const [dates, setDates] = useState([])
    const [categories, setCategories] = useState([])
    const [dataTable, setDataTable] = useState([])


    useEffect(() => {
        if (!isEmpty(data)) {
            setDataTable(data)
            handleGetDataGraphic(data)
        }
    }, [data])

    const handleGetDataGraphic = useCallback((data) => {
        let arrayVolumeDia = [];
        let arrayVolumeNoite = [];
        let arrayVolumeTotal = [];
        let arrayDatas = [];
        data.forEach(item => {
            arrayVolumeTotal.push(item.VOLUME_TOTAL)
            arrayVolumeDia.push(item.VOLUME_DIA)
            arrayVolumeNoite.push(item.VOLUME_NOITE)
            arrayDatas.push(item.date)
        });
        setVolumesDia(arrayVolumeDia)
        setVolumesNoite(arrayVolumeNoite)
        setVolumesTotal(arrayVolumeTotal)
        setDates(arrayDatas)

    }, [])

    const graphicState = useMemo(() => ({
        options: {
            plotOptions: {
                bar: {
                    columnWidth: '100%',
                }

            },
            chart: {
                id: "basic-bar",
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: false,
                    },
                },
                zoom: {
                    enabled: true,
                    type: 'x',
                    resetIcon: {
                        offsetX: -30,
                        offsetY: 0,
                        fillColor: '#fff',
                        strokeColor: '#37474F'
                    },
                    selection: {
                        background: '#90CAF9',
                        border: '#0D47A1'
                    }
                }
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                curve: 'smooth',
                colors: ['transparent'],
                width: 2,
            },
            xaxis: {
                tickPlacement: 'on',
                categories: dates,
                overwriteCategories: categories,
            }
        },

        series: [
            {
                name: "VOLUME_TOTAL",
                data: volumesTotal
            },
            {
                name: "VOLUME_DIA",
                data: volumesDia
            },
            {
                name: "VOLUME_NOITE",
                data: volumesNoite
            }
        ]


    }), [volumesDia, volumesNoite, volumesTotal, dates, categories]

    )

    const tableHeader = useMemo(() => [
        {
            id: 'date',
            label: 'Data'
        },
        {
            id: 'VOLUME_TOTAL',
            label: 'Volume Total'
        },
        {
            id: 'VOLUME_DIA',
            label: 'Volume Dia'
        },
        {
            id: 'VOLUME_NOITE',
            label: 'Volume Noite'
        },
    ]

        , [])

    useEffect(() => {

        let tempCategories = dates.filter((value) => {
            let inicio = dates[0]
            let fim = dates[dates.length - 1]
            let meio = dates[round(dates.length / 2)]
            if (value == inicio || value == meio || value == fim) {
                return true
            }
            return false
        })

        setCategories(tempCategories)

    }, [dates])

    return (
        <>
            {
                volumesTotal.length > 0 && dates.length > 0 && <Charts
                    options={graphicState.options}
                    series={graphicState.series}
                    type="bar"
                    width="100%"
                    height="300px"
                />

            }

            {
                dataTable.length > 0 && <TableSearchListdDef
                    cells={tableHeader}
                    data={dataTable}
                    size="xs"
                    paginate={3}
                    showCount
                />
            }

        </>
    )

}

GraphicAbastecimentoDiaNoite.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any),
}

GraphicAbastecimentoDiaNoite.defaultProps = {
    data: []

}


